import UserNotification from "util/UserNotification";
import translateApiError from "util/translateApiError";
export async function onError(promise, handler) {
  try {
    return await promise;
  } catch (e) {
    handler(e);
    throw e;
  }
}
export async function onSettled(promise, handleSuccess, handleError) {
  try {
    const result = await promise;
    handleSuccess(result);
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
}
export function defaultOnError(promise, message, title) {
  return onError(promise, (error) => {
    var _a;
    return UserNotification.error(`${message}: ${(_a = translateApiError(error)) != null ? _a : error}`, title);
  });
}
export const wrapWithOnError = (fn, message, title) => (...args) => defaultOnError(fn(...args), message, title);
